import React, { useEffect } from "react"
import { Form, Button, Container, Modal, Row, Col } from "react-bootstrap"
import * as yup from "yup"
import { yupResolver } from "@hookform/resolvers/yup"
import "./forgot.css"
import { useForgetPasswordMutation } from "../../services/authServices"
import { toast } from "react-toastify"
import { useForm } from "react-hook-form"
import { useNavigate } from "react-router-dom"
import { FormInput } from "../form"
import forgotimage from "../../img/forgot.jpg"

interface signinProps {
  onHide?: () => void
  show?: boolean
}

interface LoginUser {
  email: string
}

const Forgot = ({ onHide = () => {}, show }: signinProps) => {
  const navigate = useNavigate()

  const [forgetPassword, { isError, error, data }] = useForgetPasswordMutation()

  const schemaResolver = yupResolver(
    yup.object().shape({
      email: yup.string().required("Please enter login id"),
    }),
  )

  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<LoginUser>({
    resolver: schemaResolver,
  })

  // useEffect(() => {
  //   if (error) {
  //     toast.error((error as any).data?.message, { toastId: 44 })
  //   }
  // }, [isError])

  useEffect(() => {
    if (data?.message) {
      toast.success(data?.message, { toastId: 1 })

      setTimeout(() => {
        // navigate("/dash/main")
        handleClose()
      }, 900)
    }
  }, [data])

  const handleClose = () => onHide()

  const onSubmit = async (values: any) => {
    const payload = {
      email: values.email,
    }
    forgetPassword(payload)
  }

  return (
    <>
      <Container>
        <Modal
          show={show}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton onHide={handleClose} />
          <Modal.Body>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <div className="signin-form container">
              <Row className="align-items-center">
                  <Col md={6}>
                    <div className="form-content">
                      <Container>
                        <h3>Forgot</h3>
                      </Container>
                      <Container>
                        <div className="emailform ">
                          <FormInput
                            name="email"
                            title="Email"
                            placeholder="Email"
                            register={register}
                            errors={errors}
                          />
                        </div>
                        <div className="d-flex justify-content-center">
                          <Button
                            size="lg"
                            variant="transparent"
                            type="submit"
                            className="my-3 w-100"
                            style={{
                              backgroundColor: "#0D928D",
                              color: "white",
                            }}
                          >
                            Forgot Password
                          </Button>
                        </div>
                      </Container>
                    </div>
                  </Col>
                  <Col md={6}>
                    <div className="forgot-image">
                      <img src={forgotimage}/>
                    </div>
                  </Col>
                </Row>
              </div>
            </Form>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  )
}
export default Forgot
